/**
 * The producer's event workspace tabs. `path` is the segment after
 * `/events/:eventId/` — the same addresses the old stand-alone pages used, so
 * bookmarks and links from emails and the dashboard still land on the right
 * tab. The overview is the index (no segment).
 */
export interface EventTabDef {
  id: string;
  label: string;
  path: string;
}

export const EVENT_TABS: EventTabDef[] = [
  { id: 'overview', label: 'Overview', path: '' },
  { id: 'guests', label: 'Guests', path: 'guests' },
  { id: 'invites', label: 'Invites', path: 'invites' },
  { id: 'vendors', label: 'Vendors & Expenses', path: 'vendors' },
  { id: 'money', label: 'Money', path: 'money' },
  { id: 'timeline', label: 'Timeline', path: 'timeline' },
  { id: 'floor-plan', label: 'Floor Plan', path: 'floor-plan' },
  { id: 'seating', label: 'Seating', path: 'seating' },
  { id: 'tasks', label: 'Tasks', path: 'checklist' },
  { id: 'files', label: 'Files', path: 'files' },
  { id: 'conversations', label: 'Conversations', path: 'conversations' },
];

/** Less-used tabs, under the row's "More". */
export const EVENT_OVERFLOW_TABS: EventTabDef[] = [
  { id: 'kibuddim', label: 'Kibuddim', path: 'kibuddim' },
  { id: 'questionnaires', label: 'Questionnaires', path: 'questionnaires' },
  { id: 'notifications', label: 'Notifications', path: 'notifications' },
  { id: 'notes', label: 'Notes', path: 'notes' },
];

const ALL_TABS = [...EVENT_TABS, ...EVENT_OVERFLOW_TABS];

/** Older addresses that now live inside another tab. */
const ALIASES: Record<string, string> = { expenses: 'vendors' };

/** Which tab a path under `/events/:eventId` belongs to. */
export function activeEventTab(pathname: string, eventId: string): string {
  const base = `/events/${eventId}`;
  const rest = pathname.startsWith(base) ? pathname.slice(base.length) : '';
  const segment = rest.split('/').filter(Boolean)[0] ?? '';
  const path = ALIASES[segment] ?? segment;
  return ALL_TABS.find((t) => t.path === path)?.id ?? 'overview';
}

export function eventTabPath(eventId: string, tabId: string): string {
  const tab = ALL_TABS.find((t) => t.id === tabId);
  return tab && tab.path ? `/events/${eventId}/${tab.path}` : `/events/${eventId}`;
}
